import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Button } from '../../components/ui/button';
import { CheckCircle } from 'lucide-react';

const YOUNITED_FLOW_LOGO = 'https://customer-assets.emergentagent.com/job_de5fd55a-ccb9-4790-966a-0bfe35cdacca/artifacts/fk9u448b_IMG_0370.jpeg';

const JustificatifSuccess = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { type, title } = location.state || { type: 'document', title: 'Document' };

  // Auto redirect after 5 seconds
  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/client/dashboard');
    }, 5000);
    return () => clearTimeout(timer);
  }, [navigate]);

  const getSuccessMessage = () => {
    switch (type) {
      case 'justificatif_identite':
        return 'Votre pièce d\'identité a bien été envoyée.';
      case 'releve_identite_bancaire':
      case 'releve_compte':
        return 'Vos informations bancaires ont bien été récupérées.';
      case 'avis_imposition':
        return 'Votre avis d\'imposition a bien été récupéré.';
      default:
        return 'Vos informations ont bien été enregistrées.';
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-white border-b border-gray-200 py-4 px-6">
        <div className="max-w-4xl mx-auto">
          <img src={YOUNITED_FLOW_LOGO} alt="Younited" className="h-10 w-auto object-contain" />
        </div>
      </div>

      {/* Success Content */}
      <div className="max-w-xl mx-auto px-4 py-16 text-center">
        {/* Success Icon */}
        <div className="flex justify-center mb-8">
          <div className="w-24 h-24 bg-green-100 rounded-full flex items-center justify-center">
            <CheckCircle className="h-14 w-14 text-green-500" />
          </div>
        </div>

        {/* Title */}
        <h1 className="text-2xl font-bold text-gray-900 mb-4">
          {title} validé !
        </h1>

        {/* Message */}
        <p className="text-lg text-gray-700 mb-4">
          {getSuccessMessage()}
        </p>

        <p className="text-gray-600 mb-8">
          Notre équipe va vérifier vos documents sous <strong>48 heures</strong>.
          Vous recevrez une notification dès que votre document sera validé.
        </p>

        {/* Info Box */}
        <div className="bg-purple-50 border border-purple-200 rounded-lg p-6 mb-8">
          <div className="flex items-start space-x-3">
            <span className="text-2xl">📋</span>
            <div className="text-left">
              <h3 className="font-semibold text-gray-900 mb-1">Prochaine étape</h3>
              <p className="text-sm text-gray-700">
                Retournez sur votre tableau de bord pour compléter les autres justificatifs 
                et accélérer le traitement de votre dossier.
              </p>
            </div>
          </div>
        </div>

        {/* Return Button */}
        <Button
          onClick={() => navigate('/client/dashboard')}
          className="text-white font-semibold px-8 py-4 text-base"
          style={{ backgroundColor: '#8B5CF6' }}
        >
          Retour au tableau de bord
        </Button>

        {/* Auto redirect message */}
        <p className="text-sm text-gray-500 mt-6">
          Redirection automatique dans 5 secondes...
        </p>
      </div>

      {/* Footer */}
      <div className="fixed bottom-0 left-0 right-0 bg-gray-100 border-t py-4">
        <div className="max-w-4xl mx-auto px-4 flex flex-wrap justify-center gap-4 text-xs text-gray-500">
          <a href="#" className="hover:underline">Mentions légales</a>
          <span>•</span>
          <a href="#" className="hover:underline">Utilisation des données</a>
          <span>•</span>
          <span className="hover:underline cursor-pointer" onClick={() => navigate('/client/help-contact')}>Aide & Contact</span>
        </div>
      </div>
    </div>
  );
};

export default JustificatifSuccess;
